import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../auth/auth.service';
import { FacultyModel } from '../../model/faculty.model';
import { SuggestedTrainerModel } from '../../model/suggested_trainer.model';
import { FacultyService } from '../../providers/faculty.service';

@Component({
	selector: 'app-suggested-trainers-edit-dialog',
	templateUrl: './suggested-trainers-edit-dialog.component.html',
	styleUrls: [ './suggested-trainers-edit-dialog.component.css' ]
})
export class SuggestedTrainersEditDialogComponent implements OnInit {
	mItems: Array<SuggestedTrainerModel> = [];

	selectedItem: SuggestedTrainerModel;
	mFacultyService: FacultyService;
	errorMessage: string = '';
	isLoading: boolean = true;
	actionDisabled = false;
	varShowActionDialog: boolean = false;

	constructor(
		private fb: FormBuilder,
		public snackBar: MatSnackBar,
		private mApiService: AuthService,
		private dialogRef: MatDialogRef<SuggestedTrainersEditDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	onNoClick(): void {
		this.dialogRef.close();
	}

	ngOnInit(): void {
		this.selectedItem = this.data;
	}

	getSuggestedTrainers() {
		this.mApiService
			.getSuggestedTrainersByStatus('PENDING')
			.subscribe((p) => (this.mItems = p), (e) => (this.errorMessage = e), () => (this.isLoading = false));
	}

	openSnackBar(message: string) {
		this.snackBar.open(message, '', { duration: 500 });
	}

	public takeSuggestedTrainerAction(action: string) {
		this.actionDisabled = true;
		this.selectedItem.Status = action;
		this.selectedItem.ApprovedByUserId = this.mApiService.authUser.userId;

		this.mApiService.takeSuggestedTrainerAction(this.selectedItem).subscribe(
			(p) => {
				if (p) {
					if (p.Success == 0) {
						this.varShowActionDialog = false;
						this.getSuggestedTrainers();
						this.openSnackBar(p.Message);
						this.dialogRef.close();
					} else {
						this.varShowActionDialog = false;
						this.openSnackBar(p.Message);
						this.dialogRef.close();
					}
				}
			},
			(e) => (this.errorMessage = e),
			() => {
				this.actionDisabled = false;
				this.isLoading = false;
			}
		);
	}
}
